<template>
<div class="wl-new-manager-wrapper">
    <div class="n-head-con clearfix">
        <img :src="logo" alt class="fl logo-img-val" />
        <div class="fr clearfix">
            <div class="fl head-link-con head-link-con-1">
                <img class="head-img-val" src="https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/DY5HjYdBPnwfFK8h.png" alt />
                <span>后台首页</span>
            </div>
            <div class="fl head-link-con" @click="toIndexHome">
                <img class="head-img-val" src="https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/Nzd38WkSbAmjysjP.png" alt />
                <span>前台首页</span>
            </div>
            <div class="fl head-link-con" @click="edit(userInfo.userId)" v-if="userInfo.userType==2">
                <img :src="userInfo.avatar || userLogo" alt class="head-img-val user-avatar-con" />
                <span>{{userInfo.userName}}</span>
                <span> 个人中心</span>
            </div>
            <div class="fl head-link-con" v-if="userInfo.userType!=2">
                <img :src="userInfo.avatar || userLogo" alt class="head-img-val user-avatar-con" />
                <span>{{userInfo.userName}}</span>
            </div>
            <div class="fr out-system-btn" @click="outLogin()">退出</div>
        </div>
    </div>
    <div class="manager-main-con">
        <div v-if="list.length > 0" class="type-list-con clearfix">
            <div class="fl type-li-item" :style="{backgroundImage:'url('+ item.CertificateCover +')'}" @click="goCertificateWeb(item.id)" v-for="(item,index) in list" :key="index">
                <div class="type-li-item-con">
                    <div class="type-li-intro">
                        <p class="p-title-1">{{item.CertificateName}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="add-cerfity-con" v-else>
            <div>
                <img :src="noCerfityImg" />
                <p class="p-no-cerfity-title-con">还没有任何证书哦！</p>
            </div>
            <p>
                <el-button class="add-cerfity-btn">添加证书</el-button>
            </p>
        </div>
    </div>
    
</div>
</template>

<script>
import {
    MU_UPATE_AUTH,
    MU_UPATE_SCHOOL
} from "store/index";
export default {
    data() {
        return {
            userLogo: require("assets/images/default_avatar3.png"),
            avatar: "https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/F8Z5WzTzxS3CDntG.png",
            logo: "https://66ykt.oss-cn-hangzhou.aliyuncs.com/66ykt/ori/seiwar2qh5tm31taautdra/Wy4DxkEdmdYZw2PD.png",
            bgImg1: "https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/JRDPNpPSQPCZs7kG.png",
            bgImg2: "https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/BaEhD6m87xRmt5an.png",
            bgImg3: "https://file.clpp.org.cn/ykt/ori/2tv3anmogrronofrjgafcw/Xewph7rmjpHXCjEY.png",
            bgImg4: "https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/YDNM5SamJEcPkbR3.png",
            bgImg5: "https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/HSeYfaGSim2K7F8Q.png",
            bgImg6: "https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/rzxenMYYYxHAktQF.png",
            bgImg7: "https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/CQZ2RDmYSBMGM7Ka.png",
            bgImg8: "https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/8jz5YJeNC37Mybjy.png",
            bgImg9: "https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/dcAKiz5er3miZSeX.png",
            bgImg10: "https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/NGjRjd4YxCteCWAF.png",
            bgImg11: "https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/r8eejhEzt5eSBtnG.png",
            list: [],
            noCerfityImg: require('assets/images/no-cerfity-img.png')
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.auth;
        },
        association: function () {
            return this.$store.state.association;
        }
    },
    created() {
        this.getCertificateList();
    },
    methods: {
        getCertificateList() {
            var that = this;
            this.$http.post("/api/XOrg/Certificate/getCertificateList").then(function (rst) {
                if (rst.code > 0) {
                    that.list = rst.list;
                } else {
                    that.$message.warning(rst.msg);
                }
            });
        },
        goCertificateWeb(certificateId) {
            if (this.userInfo.userType == 5||this.userInfo.userType == 15) {
                this.$router.push({
                    name: 'systemManager',
                    params: {
                        certificateId: certificateId
                    }
                });
            } else if (this.userInfo.userType == 2) {
                this.$router.push({
                    name: 'teaApply',
                    params: {
                        certificateId: certificateId
                    }
                });
            }
        },
        toIndexHome() {
            const resolved = this.$router.resolve({
                name: "xHome"
            });
            window.open(resolved.href, "_blank");
        },
        edit(id) {
            this.$router.push({
                name: "TeacherProfile",
                params: {
                    id: id
                }
            });
        },
        outLogin() {
            var that = this;
            this.$http.post("/api/XOrg/XLogin/outLogin").then(function (rst) {
                if (rst.code > 0) {
                    that.$store.commit(MU_UPATE_AUTH, null);
                    that.$router.push({
                        name: "xHome"
                    });
                } else {
                    that.$message.warning(rst.msg);
                }
            });
        },
    }
};
</script>

<style lang="scss">
.wl-new-manager-wrapper {
    height: 100%;
    background: #f0f0f0;

    .n-head-con {
        height: 55px;
        background: #fff;
        box-shadow: 0px 0px 5px 0px rgba(0, 55, 112, 0.1);

        .logo-img-val {
            margin: 7px 0 0 30px;
            height: 41px;
        }

        .head-link-con {
            margin: 7px 30px 0 0;
            height: 38px;
            padding: 0 10px;
            line-height: 38px;
            cursor: pointer;
        }

        .head-img-val {
            margin-right: 10px;
            vertical-align: -7px;
        }

        .user-avatar-con {
            vertical-align: -11px;
            border-radius: 50%;
            width: 32px;
            height: 32px;
        }

        .head-link-con-1 {
            background: #e6ecf0;
        }

        .head-link-con:hover {
            background: #e6ecf0;
            color: #00468e;
        }

        .out-system-btn {
            padding-left: 20px;
            color: #e22e54;
            font-size: 16px;
            margin: 16px 30px 0 0;
            border-left: 2px solid #cccccc;
            line-height: 1;
            cursor: pointer;
        }
    }

    .manager-main-con {
        height: calc(100% - 55px);
        overflow: auto;

        .add-cerfity-con {
            padding-top: 80px;

            .p-no-cerfity-title-con {
                margin: 20px 0;
            }

            .add-cerfity-btn {
                color: #2D82FF;
                border-color: #2D82FF;
                background: none;
                width: 140px;
            }
        }

        .add-cerfity-con {
            text-align: center;
        }

        .type-list-con {
            margin: 0 auto;
            padding-bottom: 30px;
            width: 1400px;
        }

        .type-li-item {
            margin: 55px 66px 0 0;
            width: 300px;
            height: 200px;
            background: rgba(0, 0, 0, 0);
            background-size: cover;
            background-position: center top;
            text-align: center;
            color: #fff;
            font-size: 22px;
            cursor: pointer;

            a {
                display: block;
                height: 100%;
                color: #fff;
            }

            .p-title-1 {
                transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            }

            .p-title-2 {
                margin: 10px 15px 0;
                font-size: 14px;
                line-height: 1.5;
                opacity: 0;
                transition: all 0.4s cubic-bezier(0.5, 0, 0.2, 1);
            }
        }

        .type-li-item:nth-child(4n) {
            margin-right: 0;
        }

        .type-li-item-2 {
            line-height: 1;

            .p-title-last-1,
            .p-title-last-2 {
                margin-top: 50px;
            }
        }

        .type-li-item-8 {
            line-height: 1;

            .p-title-last-1,
            .p-title-last-2 {
                margin-top: 50px;
            }
        }

        .type-li-item-10 {
            line-height: 1;

            .p-title-last-1,
            .p-title-last-2 {
                margin-top: 50px;
            }
        }

        .type-li-item-11 {
            line-height: 1;

            .p-title-last-1,
            .p-title-last-2 {
                margin-top: 50px;
                font-size: 18px;
            }
        }

        .type-li-item-con {
            position: relative;
            height: 100%;
            background: rgba(0, 0, 0, 0.4);
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .type-li-intro {
            position: absolute;
            top: 88px;
            left: 0;
            bottom: 0;
            width: 100%;
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }

        // .type-li-item-con:hover {
        //   background: rgba(0, 0, 0, 0.6);
        //   .p-title-1 {
        //     margin-top: -40px;
        //   }
        //   .p-title-2 {
        //     opacity: 1;
        //   }
        // }
        .type-li-item-data {

            .p-title-last-1,
            .p-title-last-2 {
                font-size: 22px;
                margin-bottom: 15px;
            }

            .p-title-last-1 {
                margin: 40px 0 15px 0;
            }
        }
    }
}

@media only screen and (max-width: 1366px) {
    .wl-new-manager-wrapper {
        .manager-main-con {
            height: calc(100% - 55px);
            overflow: auto;

            .type-list-con {
                margin: 0 auto;
                width: 1200px;
            }

            .type-li-item {
                margin: 25px 32px 0 0;
                width: 276px;
                height: 170px;
            }

            .type-li-item-1 {
                .p-title-1 {
                    margin: 26px 0 20px 0;
                }
            }

            .type-li-item-2 {
                line-height: 1;

                .p-title-last-1,
                .p-title-last-2 {
                    margin-top: 50px;
                }
            }

            .type-li-item-8 {
                line-height: 1;

                .p-title-last-1,
                .p-title-last-2 {
                    margin-top: 50px;
                }
            }

            .type-li-item-10 {
                line-height: 1;

                .p-title-last-1,
                .p-title-last-2 {
                    margin-top: 50px;
                }
            }

            .type-li-item-11 {

                .p-title-last-1,
                .p-title-last-2 {
                    margin-top: 40px;
                    font-size: 17px;
                }
            }
        }
    }
}
</style>
